const dirObj = {
  1: 'asc',
  '-1': 'desc',
};

function getSort(sortGridInfo) {
  let sort = '';
  let sortInfo = sortGridInfo[0];

  const dirInfo = dirObj[sortInfo.dir.toString()];
  if (sortInfo.dir) {
    if (sortInfo.name.startsWith('diseaseClassName')) {
      sort += `&order_by=${sortInfo.name.replaceAll('_', '')}&order=${dirInfo}`;
    } else if (sortInfo.name.startsWith('ddaRelation')) {
      sort += `&order_by=rela`;
    } else if (sortInfo.name === 'symbol') {
      sort += `&order_by=symbol_keyword&order=${dirInfo}`;
    } else if (sortInfo.name === 'disease_model') {
      sort += `&order_by=dmt&order=${dirInfo}`;
    } else if (sortInfo.name === 'disease_model_in_doc') {
      sort += `&order_by=dmt_doc&order=${dirInfo}`;
    } else if (sortInfo.name === 'sex_in_doc') {
      sort += `&order_by=sex_doc&order=${dirInfo}`;
    } else if (sortInfo.name === 'GTP') {
      sort += `&order_by=tces&order=${dirInfo}`;
    } else {
      sort += `&order_by=${sortInfo.name}&order=${dirInfo}`;
    }
  }

  return sort;
}

function getFiltersMap() {
  // [columnName, filterParameterName]
  const keyValue = [
    // disease
    ['numVariantsAssociatedToDisease', 'num_variants'],
    ['numGenesAssociatedToDisease', 'num_genes'],
    ['ddaRelation', 'rela'],
    ['disease_prevalence_class', 'disease_prevalence_class'],
    ['prevalence', 'disease_prevalence_class'],
    ['disease_prevalence_type', 'disease_prevalence_type'],
    ['disease_prevalence_geo_area', 'disease_prevalence_geo_area'],
    ['disease_inheritance', 'disease_inheritance'],
    ['disease1_UMLSCUI', 'disease1_UMLSCUI'],
    ['disease2_UMLSCUI', 'disease2_UMLSCUI'],
    ['numChemicals', 'numChemicals'],
    // drugs
    ['chemID', 'chem_ids_filter'],
    ['chemPrefName', 'chem_name'],
    ['chemMoleculeType', 'chem_molecule_type'],
    ['numberChemsIncludedInEvidence', 'numberChemsIncludedInEvidence'],
    // gda/summary
    ['chemIDs', 'chem_ids_filter'],
    ['diseaseUMLSCUI', 'disease_filter'],
    ['geneNcbiID', 'gene_ncbi_id_filter'],
    ['geneDSI', 'dsi'],
    ['geneDPI', 'dpi'],
    ['genepLI', 'pli'],
    ['EL', 'el'],
    ['EI', 'ei'],
    ['geneProteinClassNames', 'gene_protein_class_names'],

    // gda/evidences
    ['associationType', 'association_type'],
    ['disease_model', 'dmt'],
    ['disease_model_in_doc', 'dmt_doc'],
    ['sex_in_doc', 'sex_doc'],

    // vda/summary
    ['variantStrID', 'variant_name'],
    ['variantDSI', 'dsi'],
    ['variantDPI', 'dpi'],
    ['diseaseName', 'disease_name'],
    ['geneNcbiIDs', 'gene_ncbi_id_filter'],
    ['gene_ensembl_id', 'gene_ensembl_id'],

    // vda/evidences
    ['diseaseType', 'disease_type'],
    ['geneSymbol', 'gene_symbol'],
    ['mostSevereConsequences', 'most_severe_consequences'],
    ['sentenceHTML', 'sentence_text'],
    ['clinical_significance', 'clinical_significance'],
    ['association', 'association'],

    // genes/GDAs/summary
    ['diseaseClassName_MSH', 'disease_class_name_MSH'],
    ['diseaseClassName_UMLS', 'disease_class_name_UMLS'],
    ['diseaseClassName_DO', 'disease_class_name_DO'],
    ['diseaseClassName_HPO', 'disease_class_name_HPO'],

    // variants/all
    ['strID', 'variant_name'],
    ['DSI', 'dsi'],
    ['DPI', 'dpi'],
    ['DBSNPclass', 'dbsnp_class'],
    ['Alleles', 'alleles'],
    ['genome', 'genome'],
    ['alleleFreqGenome', 'allele_freq_genome'],
    ['exome', 'exome'],
    ['alleleFreqExome', 'allele_freq_exome'],
    ['numDiseasesAssociatedToVariant', 'num_diseases'],
    ['numPublications', 'num_publications'],
    ['firstRef', 'yearInitial'],
    ['lastRef', 'yearFinal'],
    ['polyphen_score', 'polyphen'],
    ['sift_score', 'sift'],
    ['gene_ncbi_id', 'gene_ncbi_id'],
    ['gene_ensembl_id', 'gene_ensembl_id'],

    // gene/all
    ['proteins', 'protein'],
    ['PLI', 'pli'],
    ['GTP', 'disease_class_name_MSH'],
    ['ncbiID', 'gene_ncbi_id_filter'],
    ['proteinClassIDs', 'protein_class'],
    ['pathwayName', 'pathway_name'],
    ['pathwayID', 'pathway_id'],

    // gda/all
    ['geneProteinStrIDs', 'gene_protein_str_i_ds'],
    ['chemsInSentence', 'chem_name'],
    ['APT', 'icite_apt'],
  ];

  return new Map(keyValue as [string, string][]);
}

const wholeNumbersAttributeNames = [
  'numPublications',
  'numPublications_GDA',
  'numPublications_VDA',
  'numPMIDsupportingAssociation',
  'firstRef',
  'lastRef',
  'yearInitial',
  'yearFinal',
  'pmYear',
  'timestamp',
  'numDBSNPsupportingAssociation',
  'numDiseasesAssociatedToVariant',
  'numDiseasesAssociatedToGene',
  'numVariantsAssociatedToGene',
  'numVariantsAssociatedToDisease',
  'numGenesAssociatedToDisease',
  'numberChemsIncludedInEvidence',
  'numChemicals',
  'chemNumPublications',
  'chemNumPublicationsGDAs',
  'chemNumPublicationsGDA',
  'chemNumGDAs',
  'chemNumPublicationsVDAs',
  'chemNumPublicationsVDA',
  'chemNumVDAs',
  'ngenes_diseaseID_1',
  'nvariants_diseaseID_1',
  'ngenes_diseaseID_2',
  'nvariants_diseaseID_2',
  'shared_genes',
  'shared_variants',
  'exome',
  'genome',
  'gene_ncbi_id',
];

const notEqualOperators = ['lt', 'gt'];
const CAMEL_CASE_EMPTINESS_COLUMNS = new Set(['disease_model', 'disease_model_in_doc', 'sex', 'sex_in_doc']);

function getEmptinessFilterValue(
  columnName: string,
  emptiness: 'not_empty' | 'is_empty',
): 'not_empty' | 'is_empty' | 'notEmpty' | 'isEmpty' {
  if (!CAMEL_CASE_EMPTINESS_COLUMNS.has(columnName)) return emptiness;
  return emptiness === 'not_empty' ? 'notEmpty' : 'isEmpty';
}

function getMinFilterString(filterName, filterParam) {
  return `&min_${filterName}=${filterParam}`;
}

function getMaxFilterString(filterName, filterParam) {
  return `&max_${filterName}=${filterParam}`;
}

function getEqualFilterString(filterName, minValue, maxValue) {
  let filter = getMinFilterString(filterName, minValue);
  filter += getMaxFilterString(filterName, maxValue);

  return filter;
}

function setMinValue(filterParam, valueName, operator) {
  const minValueModifier = notEqualOperators.includes(operator) ? -0.005 : 0.005;

  const minValue = (filterParam - minValueModifier).toFixed(4);
  if (wholeNumbersAttributeNames.includes(valueName)) {
    if (!notEqualOperators.includes(operator)) return filterParam;
    return filterParam + 1;
  }

  return minValue;
}

function setMaxValue(filterParam, valueName, operator) {
  const maxValueModifier = notEqualOperators.includes(operator) ? -0.005 : 0.005;

  const maxValue = (filterParam + maxValueModifier).toFixed(4);

  if (wholeNumbersAttributeNames.includes(valueName)) {
    if (!notEqualOperators.includes(operator)) return filterParam;
    return filterParam - 1;
  }

  return maxValue;
}

function getStringFilter(currFilter, value, operator = 'eq') {
  if (currFilter === 'chromosome') value = value.toUpperCase();

  // Handle contains operator by prefixing the value with 'contains_'
  if (operator === 'contains') {
    return `&${currFilter}=contains_${value}`;
  }

  return `&${currFilter}=${value}`;
}

function getSelectFilter(operator, currFilter, value) {
  if (operator === 'eq') {
    return `&${currFilter}=${value}`;
  }

  return '';
}

function getNumberFilter(operator, currFilter, value, name) {
  const numFilter = parseFloat(value);

  if (
    Number.isNaN(numFilter) ||
    value.match(/[^0-9.]/) ||
    (wholeNumbersAttributeNames.includes(name) && numFilter % 1 !== 0)
  )
    return '';

  let minValue = setMinValue(numFilter, name, operator);
  let maxValue = setMaxValue(numFilter, name, operator);

  if (operator === 'eq') {
    return getEqualFilterString(currFilter, minValue, maxValue);
  } else if (operator === 'gt' || operator === 'gte') {
    return getMinFilterString(currFilter, minValue);
  } else if (operator === 'lt' || operator === 'lte') {
    return getMaxFilterString(currFilter, maxValue);
  }
}

function getFilters({ filterValue }) {
  const filtersMap = getFiltersMap();
  let totalFilter = '';

  filterValue.forEach(filter => {
    const { value, type, name, operator } = filter;
    const emptiness = filter.emptiness;
    const currFilter = filtersMap.has(name) ? filtersMap.get(name) : name;

    if (value === '' || value === null || value === undefined) {
      if (emptiness === 'not_empty' || emptiness === 'is_empty') {
        totalFilter += `&${currFilter}=${getEmptinessFilterValue(name, emptiness)}`;
      }
      return;
    }

    if (type === 'string') {
      totalFilter += getStringFilter(currFilter, value, operator);
    }
    if (type === 'select') {
      totalFilter += getSelectFilter(operator, currFilter, value);
    }
    if (type === 'number') {
      totalFilter += getNumberFilter(operator, currFilter, value, name);
    }
  });

  return totalFilter;
}

export {
  getFilters,
  getSort,
  getFiltersMap,
  getEmptinessFilterValue,
  getMinFilterString,
  getMaxFilterString,
  getNumberFilter,
};
